import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "flex relative bg-zinc-50 min-h-[calc(100vh-85px)] lg:min-h-[calc(100vh-95px)] max-h-[calc(100vh-95px)]" }
const _hoisted_2 = { class: "w-full px-8 space-y-5 pt-11 pb-7" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", null, "Overview", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", null, "Test Results", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", null, "Appointments", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", null, "Your Patient Record", -1)
const _hoisted_7 = { class: "hidden w-full px-8 py-5 border-t border-b border-black/04 lg:block" }
const _hoisted_8 = { class: "w-full p-8 mt-auto" }
const _hoisted_9 = { class: "" }
const _hoisted_10 = { class: "flex flex-col w-full lg:w-0 flex-1 py-8 px-5 lg:px-11 max-h-[calc(100vh-95px)] min-h-[calc(100vh-85px)] lg:min-h-[calc(100vh-95px)] overflow-auto" }
const _hoisted_11 = { class: "flex items-center justify-between mb-4 lg:hidden" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("p", { class: "font-bold" }, "Menu", -1)
const _hoisted_13 = { class: "flex flex-wrap items-center justify-between mb-6 lg:flex-nowrap" }
const _hoisted_14 = {
  key: 0,
  class: "mb-5 text-4xl font-bold text-primary-700 lg:mb-0 line-clamp-1 overflow-hidden text-ellipsis"
}
const _hoisted_15 = { class: "flex items-center w-full lg:w-fit" }

import UserLayout from '@/layouts/UserLayout.vue';
import ButtonComponent from '@/components/ButtonComponent.vue';
import MenuButton from '@/components/MenuButton.vue';
import OverviewIcon from '@/components/icons/OverviewIcon.vue';
import TestResultIcon from '@/components/icons/TestResultIcon.vue';
import AppointmentIcon from '@/components/icons/AppointmentIcon.vue';
import MedicalRecordIcon from '@/components/icons/MedicalRecordIcon.vue';
import { BellIcon, Bars3Icon, XMarkIcon } from "@heroicons/vue/24/outline";

import { ref } from 'vue';
import { useRouter } from 'vue-router';


export default /*#__PURE__*/_defineComponent({
  __name: 'PortalLayout',
  props: {
    notifCount: {
        type: Number,
        default: 0
    },
    title: {
        type: String,
    },
    defaultTitle: {
        type: Boolean,
        default: true
    },
    hideNotification: {
        type: Boolean,
        default: false
    },
    showFooter: {
        type: Boolean,
        default: true,
    }
},
  setup(__props) {

const router = useRouter();
const currentRouteName = router.currentRoute.value.name;
const showMenu = ref(false);




return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(UserLayout, { showFooter: __props.showFooter }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", {
          class: _normalizeClass(["frm-portal-sidebar w-[70%] lg:w-72 min-h-[calc(100vh-85px)] lg:min-h-[calc(100vh-95px)] max-h-[calc(100vh-95px)] bg-white border-r flex flex-col", showMenu.value ? 'show' : ''])
        }, [
          _createVNode(_unref(XMarkIcon), {
            class: "absolute w-6 h-6 cursor-pointer top-4 right-4 text-primary-500 lg:hidden",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (showMenu.value = false))
          }),
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("a", {
              href: "/overview",
              class: _normalizeClass(["flex items-center py-1", _unref(currentRouteName) == 'OverviewIndex' ? 'text-primary-500 font-bold' : 'text-darkgray-400'])
            }, [
              _createVNode(OverviewIcon, { class: "mr-4" }),
              _hoisted_3
            ], 2),
            _createElementVNode("a", {
              href: "/test-results",
              class: _normalizeClass(["flex items-center py-1", _unref(currentRouteName) == 'TestResultsIndex' || _unref(currentRouteName) == 'TestResultsView' ? 'text-primary-500 font-bold' : 'text-darkgray-400'])
            }, [
              _createVNode(TestResultIcon, { class: "mr-4" }),
              _hoisted_4
            ], 2),
            _createElementVNode("a", {
              href: "/appointment",
              class: _normalizeClass(["flex items-center py-1", _unref(currentRouteName) == 'AppointmentIndex' || _unref(currentRouteName) == 'AppointmentShow' ? 'text-primary-500 font-bold' : 'text-darkgray-400'])
            }, [
              _createVNode(AppointmentIcon, { class: "mr-4" }),
              _hoisted_5
            ], 2),
            _createElementVNode("a", {
              href: "/medical-record",
              class: _normalizeClass(["flex items-center py-1", _unref(currentRouteName) == 'MedicalRecordIndex' ? 'text-primary-500 font-bold' : 'text-darkgray-400'])
            }, [
              _createVNode(MedicalRecordIcon, { class: "mr-4" }),
              _hoisted_6
            ], 2)
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createVNode(ButtonComponent, {
              class: "w-full",
              "show-icon": false,
              text: "+ Request Booking",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_unref(router).push('/booking')))
            })
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _createVNode(MenuButton)
            ])
          ])
        ], 2),
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("div", {
              class: "flex items-center cursor-pointer text-primary-500",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (showMenu.value = true))
            }, [
              _createVNode(_unref(Bars3Icon), { class: "w-6 h-6 mr-2" }),
              _hoisted_12
            ]),
            _createElementVNode("div", null, [
              _createVNode(ButtonComponent, {
                class: "w-full",
                "show-icon": false,
                text: "+ Book Now",
                onClick: _cache[3] || (_cache[3] = ($event: any) => (_unref(router).push('/booking')))
              })
            ])
          ]),
          _createElementVNode("div", _hoisted_13, [
            (__props.defaultTitle)
              ? (_openBlock(), _createElementBlock("h1", _hoisted_14, _toDisplayString(__props.title), 1))
              : _renderSlot(_ctx.$slots, "title", { key: 1 }),
            _createElementVNode("div", _hoisted_15, [
              _renderSlot(_ctx.$slots, "fields")
            ])
          ]),
          _renderSlot(_ctx.$slots, "default")
        ])
      ])
    ]),
    _: 3
  }, 8, ["showFooter"]))
}
}

})